import React, { FC } from 'react';
import { Box, FormGroup, TextField } from '@mui/material';

interface Props {
  question: any;
  step: number;
  onChange: (qid: string, val: string, i: number, p: boolean) => Promise<void>;
  value?: string;
}

const CustomQuestionText: FC<Props> = ({ question, step, onChange, value }) => {
  return (
    <Box>
      <FormGroup>
        <TextField
          id="custom-outlined-multiline-static"
          multiline
          placeholder={question.placeholder}
          rows={4}
          value={value}
          variant="outlined"
          sx={{
            width: '96%',
          }}
          onChange={async (e: any) => {
            await onChange(question.questionId || '', e.target.value, step, false);
          }}
        />
      </FormGroup>
    </Box>
  );
};

export default CustomQuestionText;
